/* global google */
import Indoormap from './Indoormap.js'

export const MAP_TYPE_DEFAULT_SATELLITE = 1;

export default class LiveMap {

    constructor(mapDiv, startLat, startLng, zoom, mapTypeDefault) {

        if(null== mapDiv || typeof(mapDiv)=="undefined" || typeof(startLat)=="undefined" || startLat==""){
            return;
        }
            this.self = this;
            this._map = null;
            this._mapDiv = mapDiv;
            this._markers = [];
            this._circles=[];
            this._indoorMaps = [];
            this._players = new Array();
            this._clickedPositions = new Array();
            this._infoWindow = null;
            this._clickedPosition = null;
            this._clickedFullscreenButtonClb = null;
            this._isFullscreenButtonClicked = false;
            this._polylines = new Array();
            this._enablePloyLines = false; 
            this._accuracyCircle = null;
            this._clickedPosCircle=null;
            this._spotIsSolvedClb=null;
            this._spotIsFailedClb=null;
            this._spotIsInactiveClb=null;

            this._eventStartPosition = null;
            if (null !== startLat && null !== startLng) {
                this._eventStartPosition = new google.maps.LatLng(startLat,startLng);
            }
        
            this._zoom = (typeof(zoom) == "undefined") ? 12 : zoom;
            this._serverUrl = "";
            this._enableIconBubble = true;
            this._indoorMapsControl=null;
        
            this._columnId = "id";
            this._columnLat = "map_lat";
            this._columnLng = "map_lon";
            this._columnRadius="checkin_radius";
            this._columnType = "tbild";
            this._columnStatus="tstatus";
            this._columnIntNr = "waintnr";
        
            this._clickedPositionClb = null;
            this._clickedSpotPositionClb = null;

            this._waypointClickTimer = null;
            this._waypointWasDoubleClicked = false;
        
            this._teamIconSize = 40;
            this._waypoint_z_index = 0;
            this._clickedPosition_z_index = 1;
            this._useTeamIcons = true;
        
            this._setArrows = null;
            this._defaultMapTypeId = LiveMap.mapTypeIdFromEventSetting(mapTypeDefault);
            this._mapOptions = {
                zoom: this._zoom,
                streetViewControl: false,
                panControl: false,
                zoomControl: true,
                keyboardShortcuts: false,
                fullscreenControl:true,
                mapTypeControl:false,
                overviewMapControl: true,
                mapTypeId: this._defaultMapTypeId,
                gestureHandling: 'greedy'
            };
            if ((typeof(this._eventStartPosition) !== "undefined") && this._eventStartPosition !== null) {
                this._mapOptions.center = this._eventStartPosition;
            }
            this._map = new google.maps.Map(document.getElementById(this._mapDiv), this._mapOptions);
            this._infoWindow = new google.maps.InfoWindow({
                content: "..."
            });

    }

    static mapTypeIdFromEventSetting(mapTypeDefault) {
        return parseInt(mapTypeDefault, 10) === MAP_TYPE_DEFAULT_SATELLITE
            ? google.maps.MapTypeId.SATELLITE
            : google.maps.MapTypeId.ROADMAP;
    }

    setServerUrl(serverUrl) {
        this._serverUrl = serverUrl;
    }

    setZoom(zoom) {
        
        if (null !== zoom && typeof (zoom) !== "undefined") {
            this._zoom = zoom;
            this._map.setZoom(zoom);
        }
    }

    getZoom(){
        return this._map.getZoom();
    }

    printMap() {

        window.print();
        //https://productforums.google.com/forum/?hl=en#!category-topic/maps/new-feature-suggestions/b1zxZ6eotjM
        //https://developers.google.com/maps/documentation/staticmaps/?csw=1
    }
    //Column names
    setIdColumn(idColumn) {
        this._columnId = idColumn;
    }
    setLatColumn(columnLng) {
        this._columnLat = columnLng;
    }
    setLngColumn(columnLng) {
        this._columnLng = columnLng;
    }
    setTypeColumn(columnType) {
        this._columnType = columnType;
    }

    enableIconBubble(enableIconBubble) {
        this._enableIconBubble = enableIconBubble;
    }

    getMap() {
        return this._map;        
    }

    setEventStartPosition(googleLatLng) {
        this._eventStartPosition = googleLatLng;
    }

    getEventStartPosition() {
        return this._eventStartPosition;
    }

    setClickedPosition(googleLatLng) {
        this._clickedPosition = googleLatLng;
    }

    setClickedPositionClb(clb) {
        this._clickedPositionClb = clb;
    }

    setClickedSpotPosition(clb){
        this._clickedSpotPositionClb=clb;
    }

    setSpotIsSolvedProofFct(clb){
        this._spotIsSolvedClb=clb;
    }
    setSpotIsFailedProofFct(clb){
        this._spotIsFailedClb=clb;
    }
    setSpotIsInactiveProofFct(clb){
        this._spotIsInactiveClb=clb;
    }

    getClickedPosition() {
        return this._clickedPosition;
    }

    setFullscreenClickedClb(clb) {
        this._clickedFullscreenButtonClb = clb;
    }
    
    setUseTeamIcons(val) {
        this._useTeamIcons = val;
    }

    setMapStyle(json) {        
        var verifiedJson = this.getVerifiedJson(json);
        if (typeof (this._map) != 'undefined') {
            if(null != this._map && null != verifiedJson){
                var styledMapType = new google.maps.StyledMapType(verifiedJson, {name: 'STYLED MAP'});
                this._map.mapTypes.set('styled_map', styledMapType);
                this._map.setMapTypeId('styled_map');
            }else{
                //default value
                this._map.setMapTypeId(this._defaultMapTypeId);
            }
        }
    }

    setDefaultMapType(mapTypeDefault) {
        this._defaultMapTypeId = LiveMap.mapTypeIdFromEventSetting(mapTypeDefault);
        if (typeof this._map !== 'undefined' && this._map !== null) {
            this._map.setMapTypeId(this._defaultMapTypeId);
        }
    }

    /**
     * Change between satellite and roadmap
     */
    setMapType() {
        if (typeof this._map !== 'undefined' && this._map !== null) {
            // Check if current map type is satellite
            if (this._map.getMapTypeId() === google.maps.MapTypeId.SATELLITE) {
                // Switch to roadmap if current map type is satellite
                this._map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
            } else {
                // Otherwise, switch to satellite
                this._map.setMapTypeId(google.maps.MapTypeId.SATELLITE);
            }
        }
    }

    getMapStyleInvisible(){
        return [
            {"elementType": 'all', "stylers": [{"color":"#111111"}]},
            {
                "featureType": 'all',
                "elementType": 'labels.icon',
                "stylers": [{
                  "visibility": 'off'
                }]
              }
          ]
    }

    getVerifiedJson(str) {
        var res = null;
        try {
            if (typeof (str) == "object") {
                str = JSON.stringify(str);
            }

            if (typeof (str) == "string") {
                res = JSON.parse(str);
            }

        } catch (e) {
            console.log(e);
        }
        return res;
    }

    isJson(str) {
        try {
            if (typeof (str) == "string") {
                JSON.parse(str);
            }

        } catch (e) {
            return false;
        }
        return true;
    }

    /** start process to set up custom drop down */
    setIndoorMapsMode(indoorMapsData,urlIndoorMapsPrefix, setMapsVisible, eventID) {
       if((null==this._indoorMapsControl)){
            this._indoorMapsControl = new Indoormap(this._mapDiv,this._map,indoorMapsData,urlIndoorMapsPrefix, setMapsVisible, eventID,this._markers);
            this._indoorMapsControl.init();
       }
    }

    centerPositions(ar) {
        if (null === ar || typeof (ar) === "undefined") {
            return;
        }

        var bounds = new google.maps.LatLngBounds();
        var i = 0;

        for (i in ar) {
            if (typeof (ar[i]) !== 'undefined'
                    && ar[i] !== null
                    && ar[i].position !== null
                    && ar[i].position.lat() !== 0
                    && ar[i].position.lng() !== 0) {
                bounds.extend(ar[i].position);
            }

        }

        if(this._map){
            this._map.fitBounds(bounds);
        }

        //this._map.panToBounds(bounds);
        //this._map.setCenter(bounds.getCenter());
    }

    centerClickedPositions() {
        this.centerPositions(this._clickedPositions);
    }

    centerClickedPositionsAndWaypoints() {
        this.centerPositions([...this._clickedPositions, ...this._markers]);
    }

    getClickedPositions() {
        return this._clickedPositions;
    }

    addClickedPosition(marker) {
        this._clickedPositions.push(marker);
    }

    centerWaypointPositions() {
        this.centerPositions(this._markers);
    }

    centerMarker(m1, m2) {
        this.centerPositions([m1, m2]);
    }

//Center map
    center() {
        if(this.self){
            var waypoints = this.self.getWaypoints();
            var waypointsLength = Object.keys(waypoints).length;
            var clickedPosition = this.self.getClickedPosition();
            var clickedPositions = this.self.getClickedPositions();

            if (waypoints !== null && typeof (waypoints) !== 'undefined' && waypointsLength > 0) {
                this.self.centerWaypointPositions();
            } else if (clickedPosition !== null && typeof (clickedPosition) !== 'undefined') {
                this._map.setCenter(clickedPosition);
            } else if (clickedPositions !== null && typeof (clickedPositions) !== 'undefined' && clickedPositions.length > 0) {
                this.self.centerClickedPositions();
            }
        }
    }

    getWaypoints() {
        return this._markers;
    }


    showClickedPosition(clearOldClickedPositions, title, hideAnimation, accuracy,checkinRadius,dragendClb) {
        
        var context=this;

        if (clearOldClickedPositions) {
            context.clearClickedPositions();
        }
        
        let draggable=(typeof(dragendClb)=="function");

        var marker = new google.maps.Marker({
            position: this.getClickedPosition(),
            title: null,
            animation: google.maps.Animation.DROP,
            map: this._map,
            draggable:draggable,
            zIndex: this._clickedPosition_z_index,
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 10,
                fillOpacity: 1,
                strokeWeight: 2,
                fillColor: '#5384ED',
                strokeColor: '#ffffff',
            },
            // icon: new google.maps.MarkerImage('http://www.google.com/intl/en_us/mapfiles/ms/micons/red-dot.png')
        });

        if (hideAnimation) {
            marker.animation = null;
        }

        if (typeof (title) !== 'undefined' && title !== null) {
            marker.title = title;
        }

        if (null != marker.title && typeof (marker.title) != 'undefined') {
            google.maps.event.addListener(marker, 'click', function() {
                var text = '<p>' + title + '</p>';
                if (text !== null) {
                    context._infoWindow.setContent(text);
                    context._infoWindow.open(this._map, this);
                }

                if (typeof (context._clickedPositionClb) === 'function') {
                    context._clickedPositionClb(marker);
                }
            });
        }

        google.maps.event.addListener(marker, 'dragend', function(e) {
            if (typeof (dragendClb) === "function") {
                dragendClb(this, e);
            }
        });

        if(this._clickedPositions){
            this._clickedPositions.push(marker);
            this.self.showAccuracyRadius(this.getClickedPosition(), accuracy);
            this.self.showClickedPositionRadius(this.getClickedPosition(), checkinRadius);
        }
        
    }

    showAccuracyRadius(latLng, accuracy) {

        if (null !== this._accuracyCircle) {
            this._accuracyCircle.setMap(null);
            this._accuracyCircle.length = 0;
        }

        if (accuracy) {
            this._accuracyCircle = new google.maps.Circle({
                center: latLng,
                radius: accuracy,
                map: this._map,
                fillColor: "#71B5CF",
                fillOpacity: 0.4, //opacity from 0.0 to 1.0,
                strokeColor: "#71B5CF  ", //stroke color,
                strokeOpacity: 0.6//opacity from 0.0 to 1.0
            });
        }
    }

    deleteClickedPositionRadius(){
        if (null !== this._clickedPosCircle) {
            this._clickedPosCircle.setMap(null);
            this._clickedPosCircle.length = 0;
        }
    }

    showClickedPositionRadius(latLng, radius) {

        this.deleteClickedPositionRadius();

        if (radius) {
            this._clickedPosCircle = new google.maps.Circle({
                center: latLng,
                radius: radius,
                map: this._map,
                strokeWeight:0,
                strokeColor:'#999999',
                fillColor: '#AAAAAA'
            });
        }
    }

    dec2deg(dec, bool_lat)
    {  // Nord/Süd oder Ost/West
        var direction = '';

        if (dec < 0) {
            dec *= -1;
            direction = bool_lat ? 'S' : 'W';
        } else {
            direction = bool_lat ? 'N' : 'E';
        }
        // in Grad/Min/Sek umwandeln

        var sec = 60 * (dec - Math.floor(dec));
        sec = Number(sec.toFixed(5)).toFixed(5);
        return direction + Math.floor(dec) + " " + sec;
    }

    deg2dec(deg) {
        if (deg == "") {
            return "";
        }
        
        deg=deg.replace("°"," ");
        var arr_deg = deg.split(" ");
        var direction = arr_deg[0].substring(0, 1);
        var direction_end = arr_deg[1].slice(-1);
        if (direction === 'S' || direction === 'W' || direction_end === 'S' || direction_end === 'W') {
            direction = -1;
        } else {
            direction = 1;
        }
        
        if(direction_end === 'N' || direction_end === 'E' || direction_end === 'W'|| direction_end === 'W'){
            arr_deg[1]=arr_deg[1].slice(0,-1);
            deg = arr_deg[0];
        }else{
            deg = arr_deg[0].substring(1, arr_deg[0].length);
        }
        
        
        var min=null;
        var sek=null;
        
        //Grad° Bogenminute' Bogensekunde" instead of Grad° Bogenminute'
        if(arr_deg[1].indexOf("''") > -1 || arr_deg[1].indexOf("\"")>-1){
            var arr_min_sek=arr_deg[1].split("'");
            sek=arr_deg[1].substring(arr_deg[1].indexOf("'") + 1);
            sek=sek.replace("''","").replace("\"","");
            sek = parseFloat(sek);
            sek=sek/60;
            min = arr_min_sek[0];
            min = parseInt(min);
            min=(min+sek)/60;
        }else{
            min = arr_deg[1] / 60;
        }
        
        
        deg = parseInt(deg);
        min = parseFloat(min);

        return (deg + min) * parseInt(direction);
    }

    disableMovement(disable) {
        var mapOptions;
        if (disable) {
            mapOptions = {
                draggable: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                zoomControl: false
            };
        } else {
            mapOptions = {
                draggable: true,
                scrollwheel: true,
                disableDoubleClickZoom: false,
                zoomControl: true
            };
        }
        this._map.setOptions(mapOptions);
    }

    showWaypoint(marker, useDefaultIcon, draggable, dragendClb, dragstartClb, doubleClickable, doubleClickClb, showRadius) {
        var context=this;
        var imagePath = "";
        var statusIcon = null;
        showRadius=(typeof(showRadius)=="undefined" || null==showRadius)?true:false;
        if (Object.prototype.hasOwnProperty.call(marker,this._columnLat)
                && Object.prototype.hasOwnProperty.call(marker,this._columnLng)
                && Object.prototype.hasOwnProperty.call(marker,this._columnId)
                && null !== marker[this._columnLat]
                && null !== marker[this._columnLng]) {
            //Wegpunkt oder Rätsel auf Karte anzeigen
            var myLatlng = new google.maps.LatLng(marker[this._columnLat], marker[this._columnLng]);
            var wpType = marker[this._columnType];
            var markerOptions = {
                id: marker[this._columnId],
                ev_id: marker[this._columnId],
                indoor_floor: Object.prototype.hasOwnProperty.call(marker,"indoor_floor_id") ? marker["indoor_floor_id"] : null,
                position: myLatlng,
                zIndex: this._waypoint_z_index,
                map: this._map,
                        //icon: useDefaultIcon?new google.maps.MarkerImage('http://www.google.com/intl/en_us/mapfiles/ms/micons/red-dot.png'):new google.maps.MarkerImage("/img/" + markers[i][this._columnType] + ".png")
            };

            if (draggable) {
                markerOptions.draggable = true;
                markerOptions.animation = google.maps.Animation.DROP;
            }
            if (!useDefaultIcon) {
                if (this.endsWith(wpType, '.png') || this.endsWith(wpType, '.jpg') || this.endsWith(wpType, '.jpeg')) {

                    markerOptions.icon = new google.maps.MarkerImage(wpType);
                    markerOptions.flat = true;
                    markerOptions.optimized = false;

                } else if (this.endsWith(wpType, '.gif')) {
                    markerOptions.optimized = false;
                    markerOptions.icon = new google.maps.MarkerImage(wpType);
                } else {
                    statusIcon = this.getIconSettings(marker);
                    markerOptions.icon = statusIcon;
                }
            }
            //markerOptions.opacity=0.5;

            //Wenn interne Nummer vergeben wurden ist, dann zeige sie
            //Bilder sind auf dem Server hinterlegt, falls nicht, dann führt this.generateServerImages() aus
            //Bilder mit Id >= 1000 müssen generiert werden
            if (this._enableIconBubble && Object.prototype.hasOwnProperty.call(marker,this._columnIntNr)) {

                imagePath = this._serverUrl + '/img/generatedIcons/' + wpType + '_' + marker[this._columnIntNr] + '.png';

                if (marker[this._columnIntNr] >= 1000) {
                    imagePath = this._serverUrl + '/map/marker?color=ff0000&text=' + marker[this._columnIntNr] + '&type=' + wpType
                }
                markerOptions.icon = new google.maps.MarkerImage(imagePath);
                statusIcon = null;
            }
            var myMarker = new google.maps.Marker(markerOptions);
            // remembered so refreshWaypointIcons() can swap the icon when the spot state changes
            if (statusIcon) {
                myMarker.statusIconUrl = statusIcon.url;
            }

            /* Radius*/
            
            if (showRadius && Object.prototype.hasOwnProperty.call(marker,this._columnRadius)){
                //console.log(marker[this._columnRadius]);
                var circle = new google.maps.Circle({
                    map: this._map,
                    radius: marker[this._columnRadius], 
                    strokeWeight:0,
                    strokeColor:'#999999',
                    fillColor: '#AAAAAA'
                });
                circle.bindTo('center', myMarker, 'position');
                this._circles.push({id:markerOptions.id,value:circle});
            }

            this._markers.push(myMarker);
            

            google.maps.event.addListener(myMarker, 'click', function() {
                context._waypointWasDoubleClicked = false;
                var scope = this;
                context._waypointClickTimer = setTimeout(function() {

                    if (context._waypointWasDoubleClicked) {
                        return;
                    }

                    var text = '';

                    if (scope.title !== null && scope.title !== undefined) {
                        text = '<h2>' + scope.title + '</h2>';
                    }
                    if (scope.html !== null && scope.html !== undefined) {
                        text += '<p>' + scope.html + '</p>';
                    }

                    context._infoWindow.setContent(text);

                    if (text.length > 0) {
                        context._infoWindow.open(context._map, scope);
                    }

                    if (typeof (context._clickedSpotPositionClb) === "function") {
                        context._clickedSpotPositionClb(scope);
                    }
                }, 200);

            });

            //this scope=this;
            google.maps.event.addListener(myMarker, 'dragstart', function(e) {
                //scope.disableMovement(true);
                if (typeof (dragstartClb) === "function") {
                    dragstartClb(this, e);
                }
            });

            google.maps.event.addListener(myMarker, 'dragend', function(e) {
                //scope.disableMovement(false);
                if (typeof (dragendClb) === "function") {
                    dragendClb(this, e);
                }
            });
            if (doubleClickable) {
                google.maps.event.addListener(myMarker, "dblclick", function(e) {
                    this._waypointWasDoubleClicked = true;
                    clearTimeout(this._waypointClickTimer);

                    if (typeof (doubleClickClb) === "function") {
                        doubleClickClb(this, e);
                    }
                });
            }
        }
    }

    getIconSettings(spot){
        if(spot){
            var wpType = spot[this._columnType];
            let url=this._serverUrl +"/img/waypoint_type_icons/all_sizes/55/" + wpType + "1.png";

            if(this._spotIsSolvedClb && this._spotIsSolvedClb(spot)){
                url="/img/map/check-decagram.svg";
            }else if (this._spotIsFailedClb && this._spotIsFailedClb(spot)){
                url="/img/map/close.svg";
            }else if (this._spotIsInactiveClb && this._spotIsInactiveClb(spot)){
                // monochrome counterpart of the plain "1" marker (no route overlay)
                url=this._serverUrl +"/img/waypoint_type_icons/all_sizes/55/" + wpType + "_bw.png";
            }
            return {
                url: url,
                anchor: new google.maps.Point(25,50),
                scaledSize: new google.maps.Size(50,50)
            }
        }
        return {}; //TODO default icon
    }

    /**
     * Swaps the icon of drawn waypoints whose solved/failed/inactive state changed since they were
     * drawn (route progress, hints, team sync). Only status icons from getIconSettings() are
     * touched; custom image icons and spots without a marker are left alone.
     */
    refreshWaypointIcons(spots) {
        if (!Array.isArray(spots)) {
            return;
        }
        spots.forEach((spot) => {
            var marker = spot ? this.getMarkerById(spot[this._columnId]) : null;
            if (!marker || typeof marker.statusIconUrl === 'undefined') {
                return;
            }
            var icon = this.getIconSettings(spot);
            if (icon && icon.url && icon.url !== marker.statusIconUrl) {
                marker.setIcon(icon);
                marker.statusIconUrl = icon.url;
            }
        });
    }

    showWaypoints(markers, useDefaultIcon, draggable, dragendClb, dragstartClb, doubleClickable, doubleClickClb,showRadius) {
        if (markers === null || markers === undefined) {
            console.log('Warning: Markers object is null');
            return;
        }

        this.clearOverlays();

        var i = 0;
        for (i in markers)
        {
            this.showWaypoint(markers[i], useDefaultIcon, draggable, dragendClb, dragstartClb, doubleClickable, doubleClickClb,showRadius);
        }

    }

    waypointExistOnMap(ev_id) {

        if (typeof (this._markers) != "undefined" && null != this._markers) {

            for (var i = 0; i < this._markers.length; i++) {
                var marker = this._markers[i];
                if (typeof (marker) != "undefined" && null != marker) {
                    if (marker.ev_id == ev_id) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    removeWaypoints() {
        this._removeWaypoints();
    }

    _removeWaypoints() {
        if (null !== this._markers && typeof (this._markers) !== 'undefined') {

            for (var i = 0; i < this._markers.length; i++) {
                this.removeWaypointsMarkerFromMap(this._markers[i]);
            }
            this._markers.length = 0;
            this._markers = [];

            this._circles.length=0;
            this._circles=[];
        }
    }

    removePolyLines() {
        if (this._polylines !== null) {
            this.disablePolylines();
            this._polylines.length = 0;
            this._polylines = [];
        }
    }

    removeWaypoint(marker) {
        if(marker){
            this.removeWaypointsMarkerFromMap(marker);
            this.removeWaypointsMarker(marker);
        }
    }

    removeWaypointsMarkerFromMap(marker) {
        if (null !== marker && typeof (marker) !== 'undefined') {
            marker.setMap(null);
            this.deleteCircle(marker.id);
        }
    }

    removeWaypointsMarker(marker) {
        var index = this.getWaypointIndexByMarker(marker);
        if (null !== index && null !== this._markers && typeof (this._markers) !== 'undefined') {
            this._markers.splice(index, 1);
        }
    }

    deleteCircle(id){
        //this._circles.push({id:markerOptions.id,value:circle});
        if (typeof (id) === 'undefined' || !Array.isArray(this._circles)) {
            return;
        }

        var toDelete = this._circles.findIndex((circle) => circle && circle.id == id);
        if (toDelete > -1) {
            this._circles[toDelete].value.setMap(null);
            this._circles[toDelete].value.unbind('center');
            this._circles.splice(toDelete, 1);
        }
    }

    getWaypointIndexByMarker(marker) {
        if (null !== this._markers && typeof (this._markers) !== 'undefined') {
            for (var i = 0; i < this._markers.length; i++) {
                if (this._markers[i].id === marker.id) {
                    return i;
                }
            }
        }
        return null;
    }

    endsWith(str, suffix) {
        if (typeof (str) === "string" && typeof (suffix) === "string") {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        } else {
            false;
        }
    }

    clearOverlays() {
        if (typeof (this._markers) !== 'undefined' && this._markers !== null) {
            var i = 0;
            for (i in this._markers) {
                this._markers[i].setMap(null);
            }
            this._markers = [];
        }
    }

    destroy() {
        //Polylines
        this.removePolyLines();

        //Marker
        this.removeWaypoints();

        //Players
        this.removePlayers();

        //Indoor overlays
        if(this._indoorMapsControl){
            this._indoorMapsControl.removeIndoorMaps();
        }

        //Click listener
        this.clearClickedPositions();
        this._clickedFullscreenButtonClb = null;
        this._clickedPositionClb = null;
        this._clickedSpotPositionClb=null;

        this._eventStartPosition = null;

        if (null !== this._mapOptions) {
            this._mapOptions = null;
        }

        //Map
        if (null !== this._map) {
            this._map.length = 0;
            this._map = null;
        }
    }

    clearClickedPositions() {
        if (typeof (this._clickedPositions) !== 'undefined' && this._clickedPositions !== null) {
            var i = 0;
            for (i in this._clickedPositions) {
                this._clickedPositions[i].setMap(null);
            }
            this._clickedPositions.length = 0;
            this._clickedPositions = [];
            this.deleteClickedPositionRadius();
        }
    }


    getMarkerById(id) {
        if (id !== null && id !== "" && this._markers !== null) {
            var i = 0;
            for (i in this._markers) {
                if (this._markers[i].id === id) {
                    return this._markers[i];
                }
            }
        }
        return null;
    }

    getMarkerByAttribute_(ar, attr, id) {
        if (ar !== null) {
            var i = 0;
            for (i in ar) {
                if (Object.prototype.hasOwnProperty.call(ar[i],attr) && ar[i][attr] === id) {
                    return ar[i];
                }
            }
        }
        return null;
    }

    getMarkerByAttribute(attr, id) {
        return this.getMarkerByAttribute_(this._markers, attr, id);
    }

    getClickedPositionByAttribute(attr, id) {
        return this.getMarkerByAttribute_(this._clickedPositions, attr, id);
    }

    /*
     * Adds a marker to a map and return marker
     */
    addPlayerToMap(name, lat, lng, alt, speed, bat, visible, iconUrl, isBase64) {
        let context = this;

        if (null === lat || null === lng) {
            console.warn("Can not ad player to map. Position is null");
            return;
        }

        var myLatlng = new google.maps.LatLng(lat, lng);
        var markerOptions = {
            position: myLatlng,
            map: this._map,
            title: name,
            alt: alt,
            speed: speed,
            bat: bat
                    //visible:visible Macht Icon visble
        };


        markerOptions.icon = this.createImageFromSource(iconUrl, isBase64);

        var marker = new google.maps.Marker(markerOptions);

        google.maps.event.addListener(marker, 'click', function() {
            var content = '';
            context._infoWindow.setContent('<p style="min-width:100px;text-align:center"><b>' + this.title + '</b></p>' + content);
            context._infoWindow.open(context._map, this);
        });

        return marker;
    }

    createImageFromSource(iconUrl, isBase64) {

        if (this._useTeamIcons) {
            if (iconUrl !== null && typeof (iconUrl) !== 'undefined' && iconUrl.trim() !== '') {

                if (isBase64) {
                    if (iconUrl.indexOf("data:image/png;base64,") <= 0) {
                        iconUrl = "data:image/png;base64," + iconUrl;
                    }

                    //resizedataURL(iconUrl,100,100);
                    //return;

                    //iconUrl = resizeImage(iconUrl, 0.5);
                    //console.log(iconUrl);
                    return iconUrl;

                } else {
                    return new google.maps.MarkerImage(iconUrl);
                }
            } else {
                //Default icon
                iconUrl = "/img/teamIcons/default/default.png";
                return new google.maps.MarkerImage(iconUrl,
                        null, /* size is determined at runtime */
                        null, /* origin is 0,0 */
                        null, /* anchor is bottom center of the scaled image */
                        new google.maps.Size(79, 63));

            }
        }

        return null;
    }
    
    resizedataURL(datas, wantedWidth, wantedHeight)
    {
        // We create an image to receive the Data URI
        var img = document.createElement('img');

        // When the event "onload" is triggered we can resize the image.
        img.onload()
            {        
                // We create a canvas and get its context.
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');

                // We set the dimensions at the wanted size.
                canvas.width = wantedWidth;
                canvas.height = wantedHeight;

                // We resize the image with the canvas method drawImage();
                ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

                var dataURI = canvas.toDataURL();
                
                console.log(dataURI);

                /////////////////////////////////////////
                // Use and treat your Data URI here !! //
                /////////////////////////////////////////
            }

        // We put the Data URI in the image's src attribute
        img.src = datas;
    }

    /*
     * Resize an image
     * Return: base64 encoded image
     */
    resizeImage(scr, scaleFac) {
        var imgObj = new Image();
        imgObj.src = scr;

        var imgCanvas = document.createElement("canvas"),
                imgContext = imgCanvas.getContext("2d");

        // Make sure canvas is as big as the picture
        imgCanvas.width = scaleFac * imgObj.width;
        imgCanvas.height = scaleFac * imgObj.height;

        // Draw image into canvas element
        imgContext.drawImage(imgObj, 0, 0, imgCanvas.width, imgCanvas.height);

        // Save image as a data URL
        return imgCanvas.toDataURL("image/png");
    }

    movePlayerOnMap(player, toLat, toLng, alt, speed, bat, visible, iconUrl, isBase64) {
        if (player === null || player.marker === null) {
            console.log("WARNING: player is null");
            return;
        }

        if (null === toLat || null === toLng) {
            console.log("WARNING: player position is null");
            return;
        }

        var newLatLng = new google.maps.LatLng(toLat, toLng);
        player.marker.setPosition(newLatLng);

        ////player.marker.setTitle(player.name);
        player.marker.alt = alt;
        player.marker.speed = speed;
        player.marker.bat = bat;
        player.marker.icon = this.createImageFromSource(iconUrl, isBase64);
        //player.marker.visible=visible;
    }

    setPlayersIcon(id, teamname, visible, iconUrl, isBase64) {

        var player = this.getPlayer(id);

        if (player === null || player.marker === null) {
            console.log("WARNING: player is null");
            return;
        }

        if (null === player.marker.position) {
            console.log("WARNING: player position is null");
            return;
        }

        if (typeof (iconUrl) !== 'undefined' && iconUrl !== null && iconUrl.trim() !== "") {
            var lat = player.marker.position.lat();
            var lng = player.marker.position.lng();

            if (null !== lat && null !== lng) {
                var newLatLng = new google.maps.LatLng(lat, lng);
                player.marker.setPosition(newLatLng);
                player.marker.icon = this.createImageFromSource(iconUrl, isBase64);
                player.marker.title = teamname;
                this.setPlayer(player);
            }

        }
        //player.marker.visible=visible;
    }

    isEmpty(icon) {
        if (icon !== null && typeof (icon) !== 'undefined' && icon.trim() !== '') {
            return false;
        }
        return true;
    }

    showPlayer(id, name, lat, lng, alt, speed, bat, visible, color, iconUrl, isBase64) {
        var player = this.getPlayer(id);
        //Wenn Player auf Karte, dann Position ändern
        if (player !== null) {
            this.movePlayerOnMap(player, lat, lng, alt, speed, bat, visible, iconUrl, isBase64);

            //Draw Polyline
            this.drawPolyline(id, lat, lng);

        } else {
            //Wenn Player nicht auf Karte, dann erzeugen
            var marker = this.addPlayerToMap(name, lat, lng, alt, speed, bat, visible, iconUrl, isBase64);
            var obj = {
                id: id,
                name: name,
                marker: marker
            };

            this._players.push(obj);

            //Init new Polyline
            this.initPolyline(id, lat, lng, color);
        }
    }

    /*
     * Polylines
     */


    showPolylines(enable) {
        if (enable) {
            this.enablePolylines();
        } else {
            this.disablePolylines();
        }

        this._enablePloyLines = enable;
    }
    initPolyline(id, lat, lng, color) {

        if (null !== lat && null !== lng) {

            var polyOptions = {
                strokeColor: color,
                strokeOpacity: 1.0,
                strokeWeight: 3
            };

            var poly = new google.maps.Polyline(polyOptions);
            poly.setMap(this._map);

            var newLatLng = new google.maps.LatLng(lat, lng);
            poly.getPath().push(newLatLng);

            var obj = {
                id: id,
                color: color,
                path: poly
            };
            this._polylines.push(obj);
        }
    }

    drawPolyline(id, lat, lng) {
        if (null !== lat && null !== lng) {
            var line = this.self.getPolyline(id);
            if (null != line) {
                var path = line.path.getPath();
                var newLatLng = new google.maps.LatLng(lat, lng);
                path.push(newLatLng);
            }
        }
    }

    resizeBase64Image(base64Image, MAX_WIDTH, MAX_HEIGHT, clb) {

        var canvas = document.createElement("canvas");
        canvas.setAttribute('width', MAX_WIDTH);
        canvas.setAttribute('height', MAX_HEIGHT);
        canvas.style.visibility = 'hidden';
        document.body.appendChild(canvas);



        var image = new Image();

        image.onload = function() {

            var width = image.width;
            var height = image.height;
            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }

            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, width, height);
            if (typeof (clb) === "function") {
                clb(canvas.toDataURL());
            }
        };
        image.src = base64Image;

    }

    /*
     * this res = {
     loaded:false
     };
     */
    waitUntil(res, delay) {
        if (!res.loaded) {
            setTimeout(()=> {
                console.log(res.loaded);
                if (res.loaded) {
                    return;
                } else {
                    this.waitUntil(res, delay);
                }
            }, delay);
        }
    }


    enablePlayer(id) {

        if (typeof (id) !== 'undefined') {
            var player = this.getPlayer(id);
            if(player){
                player.marker.setMap(this._map);
            }
        } else {
            if(this._players){
                for (var i = 0; i < this._players.length; i++) {
                    this._players[i].marker.setMap(this._map);
                }
            }
        }
    }

    disablePlayer(id) {

        if (typeof (id) !== 'undefined') {
            var player = this.getPlayer(id);
            if(player){
                player.marker.setMap(null);
            }
        } else {
            if(this._players){
                for (var i = 0; i < this._players.length; i++) {
                    this._players[i].marker.setMap(null);
                }
            }
        }
    }

    removePlayers() {
        if (null !== this._players) {
            this.disablePlayer();
            this._players.length = 0;
            this._players = [];
        }
    }

    zoomToPlayer(id) {
        if (typeof (id) !== 'undefined') {
            var player = this.getPlayer(Number(id));
            if(player){
                player.marker.setMap(this._map);
                this._map.panTo(player.marker.position);
            }
        }
    }

    zoomToWaypoint(id) {

        if (typeof (id) !== 'undefined') {
            var wp = this.self.getMarkerById(id);
            wp.setMap(this._map);
            if (wp.position.lat() !== 0 && wp.position.lng() !== 0) {
                this._map.panTo(wp.position);
            }
        }
    }

    zoomToPosition(lat, lng, level) {

        if (typeof (lat) !== 'undefined' && typeof (lng) !== 'undefined' && null !== lat && null !== lng) {
            //var latlng = new google.maps.LatLng(lat, lng);

            if (typeof (level) !== 'undefined' && level !== null) {
                this._map.setZoom(level);
            }
            //this._map.panTo(latlng);
            //this._map.setCenter(latlng);
        }
    }
    
    /** 
     * Set the zoom on map
     * @param level -> if level is -1 we will make a zoom out
    */
    setZoomOnMap(level) {
        if (typeof this._map !== 'undefined' && this._map !== null) {
            // Get the current zoom level
            let currentZoom = this._map.getZoom();
            // Increase the current zoom level by the specified amount
            let newZoom = currentZoom + level;
            // Set the new zoom level
            this._map.setZoom(newZoom);
        }
    }

    panToPosition(lat, lng, level) {

        if (typeof (lat) !== 'undefined' && typeof (lng) !== 'undefined' && null !== lat && null !== lng) {
            var latlng = new google.maps.LatLng(lat, lng);

            if (typeof (level) !== 'undefined' && level !== null) {
                this._map.setZoom(level);
            }
            this._map.panTo(latlng);
            this._map.setCenter(latlng);
        }
    }

    zoomToClickedPosition(id) {

        if (typeof (id) !== 'undefined') {
            var wp = this.self.getClickedPositionByAttribute(this._columnId, id);
            wp.setMap(this._map);
            this._map.panTo(wp.position);
        }
    }
    /*
     * Shows a Path of a team with id
     * @param {integer} id - optional
     * @returns {undefined}
     */
    enablePolylines(id) {

        if (typeof (id) !== 'undefined') {
            var line = this.getPolyline(id);
            if(line){
                line.path.setMap(this._map);
            }
        } else {
            if(this._polylines){
                for (var i = 0; i < this._polylines.length; i++) {
                    this._polylines[i].path.setMap(this._map);
                }
            }
        }
    }

    disablePolylines(id) {
        if (typeof (id) !== 'undefined') {
            var line = this.getPolyline(id);
            if(line){
                line.path.setMap(null);
            }
        } else {
            //alle linien entfernen
            if(this._polylines){
                for (var i = 0; i < this._polylines.length; i++) {
                    this._polylines[i].path.setMap(null);
                }
            }
        }
    }

    getPolyline(id) {
        for (var i = 0; i < this._polylines.length; i++) {
            if (this._polylines[i].id === id) {
                return this._polylines[i];
            }
        }
        return null;
    }



    /*
     * Returns null or the palyer object
     */
    getPlayer(id) {
        for (var i = 0; i < this._players.length; i++) {
            if (this._players[i].id === id) {
                return this._players[i];
            }
        }
        return null;
    }

    setPlayer(player) {
        for (var i = 0; i < this._players.length; i++) {
            if (this._players[i].id === player.id) {
                this._players[i] = player;
                return true
            }
        }
        return false;
    }


    playerExists(id) {
        if (this.getPlayer(id) === null) {
            return false;
        } else {
            return true;
        }
    }

    removePlayer(id) {
        for (var i = 0; i < this._players.length; i++) {
            if (this._players[i].id === id) {
                this._players.splice(i, 1);
                break;
            }
        }
    }

}



